import { Component } from '@angular/core';
import { DeleteBase } from '../../../_classes/delete-base.class';
import IMetadata from '../../../_interfaces/IMetadata';
import { SessionService } from '../../../_services/session/session.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { MetadataService } from '../../../_services/metadatas/metadata.service';
import { ButtonModule } from 'primeng/button';
import { EResources } from '../../../_resources/EResources';

@Component({
  selector: 'app-delete-button-metadata-patients',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './delete-button-metadata-patients.component.html',
  styleUrl: './delete-button-metadata-patients.component.scss',
})
export class DeleteButtonMetadataPatientsComponent extends DeleteBase<IMetadata> {
  constructor(
    public session: SessionService,
    public messageService: MessageService,
    public confirmService: ConfirmationService,
    public translate: TranslateService,
    public metadataService: MetadataService
  ) {
    super(session, confirmService, messageService, translate);
  }

  delete(): Observable<any> {
    return this.metadataService.delete(this.customers_id, this.payload.id);
  }
  getResourceName(): string {
    return EResources.PATIENTS_METADATA;
  }
}
